import type { ReactNode } from 'react';
import classnames from 'classnames';
import styles from './HorizontalFormGroupRead.module.css';

export interface IHorizontalFormGroupReadProps {
    children: ReactNode;
    noMargin?: boolean;
    valign?: boolean;
}

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function HorizontalFormGroupRead(props: IHorizontalFormGroupReadProps) {
    return (
        <div
            className={classnames(
                styles.formGroupRead,
                { 'mb-0': props.noMargin, 'layout center': props.valign },
                'formgroup form-row'
            )}
        >
            {props.children}
        </div>
    );
}
